/**
 * @module webdnn/image
 */
/** Don't Remove This comment block */
/**
 * The data order
 */
export var Order;
(function (Order) {
    /** `[Channel, Height, Width]` format */
    Order[Order["CHW"] = 0] = "CHW";
    /** `[Height, Width, Channel]` format */
    Order[Order["HWC"] = 1] = "HWC";
})(Order || (Order = {}));
/**
 * The color format
 */
export var Color;
(function (Color) {
    /** RGB format */
    Color[Color["RGB"] = 0] = "RGB";
    /** BGR format */
    Color[Color["BGR"] = 1] = "BGR";
    /** grey scale */
    Color[Color["GREY"] = 2] = "GREY";
    /** RGBA format */
    Color[Color["RGBA"] = 3] = "RGBA";
    /** BGRA format */
    Color[Color["BGRA"] = 4] = "BGRA";
})(Color || (Color = {}));



//////////////////
// WEBPACK FOOTER
// ./src/descriptor_runner/image/enums.js
// module id = 18
// module chunks = 0